<template>
  <SeoPage page-key="creazioneSitiWebLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'CreazioneSitiWebLuganoPage'
})
</script>

